var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{staticClass:"my-4 rounded",attrs:{"height":"128px","width":"128px","src":_vm.item.previewImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }